// extracted by mini-css-extract-plugin
module.exports = {"MicrosoftContacts":"MicrosoftContacts_MicrosoftContacts__3BpAy"};